export { default as PeopleManagement } from './PeopleManagement';
